// Filename: views/layout/supervisor.js
define('views/parts/chart/double-doughnut-chart',[
    // Libs
    'jquery',
    'underscore',
    'backbone',
    'mustache',
    'utils',
    // Templates
    'text!templates/parts/chart/double-doughnut-chart.html'
], function(
    // Libs
    $, _, Backbone, Mustache, U,
    // Templates
    TDoubleDoughnutChart
) {

    var VDoubleDoughnutChart = Backbone.Epoxy.View.extend({
        template: TDoubleDoughnutChart,

        regions: {
            goal: '.circle-chart-goal-complete',
            timeleft: '.circle-chart-timeleft-complete',
        },

        initialize: function(opt) {
            this.options = _.extend({ title: true }, opt);

        },

        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.options)));

            this.applyBindings();

            this.generateZones();
            var view = this.view,
                zone = this.zone;
                
            return this;
        },

    });

    return VDoubleDoughnutChart;

});

